export default __webpack_public_path__ + "static/media/img_scsc_8.7257a290.png";